module.exports = __webpack_public_path__ + "img/default-file-icon.50a653b1.svg";